"use strict";
/**
 * This is the API Reference for the Experiment Node.js Server SDK.
 * For more details on implementing this SDK, view the [documentation]
 * (https://docs.developers.amplitude.com/experiment/sdks/nodejs-sdk).
 * @module experiment-node-server
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InMemoryFlagConfigCache = exports.FlagConfigPoller = exports.FlagConfigFetcher = exports.LocalEvaluationClient = exports.Experiment = exports.RemoteEvaluationDefaults = exports.Defaults = exports.RemoteEvaluationClient = exports.ExperimentClient = exports.AmplitudeCookie = void 0;
var cookie_1 = require("./cookie");
Object.defineProperty(exports, "AmplitudeCookie", { enumerable: true, get: function () { return cookie_1.AmplitudeCookie; } });
var client_1 = require("./remote/client");
Object.defineProperty(exports, "ExperimentClient", { enumerable: true, get: function () { return client_1.ExperimentClient; } });
Object.defineProperty(exports, "RemoteEvaluationClient", { enumerable: true, get: function () { return client_1.RemoteEvaluationClient; } });
var config_1 = require("./types/config");
Object.defineProperty(exports, "Defaults", { enumerable: true, get: function () { return config_1.Defaults; } });
Object.defineProperty(exports, "RemoteEvaluationDefaults", { enumerable: true, get: function () { return config_1.RemoteEvaluationDefaults; } });
var factory_1 = require("./factory");
Object.defineProperty(exports, "Experiment", { enumerable: true, get: function () { return factory_1.Experiment; } });
var client_2 = require("./local/client");
Object.defineProperty(exports, "LocalEvaluationClient", { enumerable: true, get: function () { return client_2.LocalEvaluationClient; } });
var fetcher_1 = require("./local/fetcher");
Object.defineProperty(exports, "FlagConfigFetcher", { enumerable: true, get: function () { return fetcher_1.FlagConfigFetcher; } });
var poller_1 = require("./local/poller");
Object.defineProperty(exports, "FlagConfigPoller", { enumerable: true, get: function () { return poller_1.FlagConfigPoller; } });
var cache_1 = require("./local/cache");
Object.defineProperty(exports, "InMemoryFlagConfigCache", { enumerable: true, get: function () { return cache_1.InMemoryFlagConfigCache; } });
